"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCompleted = void 0;
const src_1 = require("..");
function orderCompleted(payload) {
    const onAction = (0, src_1.getOnAction)(); //TODO if used by any payment gateway then please add it to documentation.
    onAction && onAction(src_1.actionTypes.ORDER_COMPLETED, payload);
}
exports.orderCompleted = orderCompleted;
